import { createContext, useContext } from 'react';

export type CallPeer = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  image?: string | null;
  name: string;
};

export type CallJanusConfig = {
  janusWsUrl: string;
  janusHttpUrl: string;
  janusApiSecret: string | null;
  roomId: string;
  pin: string;
  iceServers: Array<{ urls: string | string[]; username?: string; credential?: string }>;
};

export type CallRecord = {
  id: string;
  callerId: string;
  calleeId: string;
  status: string;
  ringingTimeoutMs: number;
  createdAt: string;
  peer: CallPeer | null;
  janus: CallJanusConfig | null;
};

export type CallPhase = 'idle' | 'outgoing' | 'incoming' | 'active';

export type CallContextValue = {
  phase: CallPhase;
  call: CallRecord | null;
  startCall: (calleeId: string) => Promise<void>;
  acceptCall: () => Promise<void>;
  rejectCall: () => Promise<void>;
  endCall: () => Promise<void>;
  muted: boolean;
  cameraOff: boolean;
  toggleMute: () => void;
  toggleCamera: () => void;
  localStream: MediaStream | null;
  remoteStream: MediaStream | null;
};

export const CallContext = createContext<CallContextValue | null>(null);

export function useCall() {
  const ctx = useContext(CallContext);
  if (!ctx) throw new Error('useCall must be used within CallProvider');
  return ctx;
}

export function useCallOptional() {
  return useContext(CallContext);
}
